
import { createApp } from "vue";
import htmlUsers from "./myAccount.html";
import {$$Dic} from "../B2bTools";

const js = ({
    url: function (echangeur) {
        echangeur.addAction('sessionInfo', {}, 'form', 'form');
    },
    onLoad: function (echangeur) {
        let THIS = this;
        //
        const $$dic = new $$Dic( echangeur.form.$$dic);
        delete echangeur.form.$$dic;
        //
        const app = createApp({
            data: function () {
                return {
                    form: echangeur.form,
                }
            },
            
            methods: {

                toProfil(k) {
                    const r = echangeur.profilList.rows.find(el => (el.k == k));
                    return (r) ? r.v : k;
                },

                toDroits(object) {
                    return Object.keys(object).filter(u => (object[u]));
                },

                toGroups(array) {
                    if (!array) return [];
                    return array.map(u => this.toGroup(u))
                },

                toGroup: function (k) {
                    return $$dic.group(k).v;
                },

                toBrandnames(array) {
                    if (!array) return [];
                    return array.map(u => this.toBrandname(u))
                },

                toBrandname(_id) {
                    return $$dic.brandname(_id).v;
                },

            },
            watch: {
            },
            mounted() {
            }
        });
        app.mount(THIS.c$('._vueChargement')[0]);
    },

});

export default {
    myAccount: { js: js, html: htmlUsers }
};
